import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getCurrencyList } from "../../../services/Settings/settings"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const CurrencyList = ({ control, name, onSelectChange, disabled, placeholder }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [currencyData, setCurrencyData] = useState([])

  const loadOptions = async () => {
    const data = await getCurrencyList()
    setIsLoading(false)
    const currency = data?.data?.map(dta => {
      return {
        label: dta?.currency_code && ucfirst(dta.currency_code),
        value: dta.id,
        ...dta,
      }
    })

    setCurrencyData(currency)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={currencyData}
              // placeholder={placeholder ? placeholder : "Currency"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              isDisabled={disabled}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(".modal")}
            />
          )
        }}
      />
    </div>
  )
}

export default CurrencyList
